import { FeatureFlagService } from "@fxp/flightingsdk";
import { Constants } from "../../common/constants";
import { appSettings } from '../../environments/common/appsettingsGenerator';
import { UserInfoService } from '@fxp/fxpservices';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
interface IFlightingService {
  evaluateFeatureFlag: (
        featureFlags: string[],
        extraContextProperties?: Record<string, string | number | undefined>
    ) => Promise<any>; 
}
export class FlightingService implements IFlightingService {
    private static instance: FlightingService;
    private featureFlagService: FeatureFlagService;
    private userInfoService: UserInfoService;
    private environmentConfig = appSettings();

    private constructor() {
        this.featureFlagService = FxpServiceFactory.getServiceInstance(
            FXPServiceCatalog.FeatureFlagService
        );
        this.userInfoService = FxpServiceFactory.getServiceInstance(
            FXPServiceCatalog.UserInfoService
          );
    }

    public static getInstance(): FlightingService {
        if (!FlightingService.instance) {
            FlightingService.instance = new FlightingService();
        }
        return FlightingService.instance;
    }

    /**
     * @param featureFlags flag names to evaluate
     * @param extraContextProperties additional flighting parameters. Some rules are keyed on more
     *   than the UPN - `CESCalendarEnabledForRoleId` is evaluated against `BusinessRoleId`
     *   (GRM feature-flag.service.js:217-231), and omitting it evaluates the rule against a null
     *   role, which can silently return the wrong answer.
     */
    public async evaluateFeatureFlag(
        featureFlags: string[],
        extraContextProperties?: Record<string, string | number | undefined>
    ): Promise<any> {
        try {
            const contextProperties = {
                "UserUPN": this.userInfoService.getCurrentUserUpn(),
                ...(extraContextProperties || {}),
            };
            return await this.featureFlagService.getFeatureFlags(
              Constants.FlightingConstants.ApplicationName,
              this.environmentConfig.flightingAppEnvironment,
              featureFlags,
              contextProperties
            );
          } catch (error) {
            // Return an object with all requested flags set to false
            const flagsResponse = featureFlags.reduce((acc, flag) => {
                acc[flag] = false;
                return acc;
            }, {} as Record<string, boolean>);
            return flagsResponse;
        }
    }
}